// src/utils/api.js
const PROD_BASE = '/scans';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://api-qrt.vuneco.com'; // ohne trailing slash
const PASSCODE = process.env.REACT_APP_API_PASSCODE || '';

function normalizeToArray(payload) {
  if (Array.isArray(payload)) return payload;       // falls Backend irgendwann direkt ein Array liefert
  if (payload && Array.isArray(payload.items)) return payload.items;
  return [];
}

function buildUrl(path, params = {}) {
  const url = new URL(`${API_BASE_URL}${path}`);
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") url.searchParams.set(k, String(v));
  });
  return url.toString();
}

async function get(path = "/scans", params = {}) {
  const url = buildUrl(path, params);
  const headers = {};
  if (PASSCODE) headers["x-passcode"] = PASSCODE;

  const res = await fetch(url, { method: "GET", mode: "cors", headers });
  const text = await res.text().catch(() => "");
  let json;
  try { json = text ? JSON.parse(text) : null; }
  catch { throw new Error(`API ${res.status}: Invalid JSON\n${text?.slice(0,200)}`); }

  if (!res.ok) {
    const msg = json?.error || json?.message || text || `HTTP ${res.status}`;
    throw new Error(`GET ${path} failed: ${msg}`);
  }
  return json;
}

/** Scans holen — standardmäßig mehr (z.B. 120) damit die Karten „aktuell“ sind */
export async function getLogs(limit = 120, scanId) {
  const params = { limit };
  if (scanId) params.scanId = scanId;
  const payload = await get("/scans", params);
  return normalizeToArray(payload);
}

export async function getDevices(limit = 120) {
  const scans = await getLogs(limit);
  return [...new Set(scans.map(s => s.os || s.userAgent).filter(Boolean))];
}

export async function getQRCodes(limit = 120) {
  const scans = await getLogs(limit);
  return [...new Set(scans.map(s => s.scanId).filter(Boolean))];
}

export async function getDashboardStats(limit = 120) {
  const scans = await getLogs(limit);
  return {
    total: scans.length,
    devices: new Set(scans.map(s => s.os || s.userAgent).filter(Boolean)).size,
    qrcodes: new Set(scans.map(s => s.scanId).filter(Boolean)).size,
    ips: new Set(scans.map(s => s.ip).filter(Boolean)).size,
  };
}

export async function getScan(scanId, limit = 120) {
  const scans = await getLogs(limit);
  return scans.find(s => s.scanId === scanId);
}
